import {
  id,
  Identifiable,
  ProjectResource,
  projectResource,
} from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import {
  handleEditRequest,
  handleEditSuccess,
  handleEditFailure,
} from "./editProjectResource";
import { reduceResource } from "../resource";

const initialState = { ...projectResource, uuid: id };

function propagateEvent(
  state = initialState,
  event: Event,
): Identifiable<ProjectResource> {
  return { ...state, resource: reduceResource(state.resource, event) };
}

const reduceProjectResource = createStateReducer(
  initialState,
  {
    [events.editProjectResourceRequested]: handleEditRequest,
    [events.editProjectResourceSucceeded]: handleEditSuccess,
    [events.editProjectResourceFailed]: handleEditFailure,
  },
  propagateEvent,
);

export { reduceProjectResource };
